import callAPiBase from './base';

const integrationFenceApi = {
  get: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/integrationFenceList',
      method: 'GET',
      useToken: true,
      title: 'IntegrationFence - Get List',
      params,
    }),
  create: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/integrationFenceCreate',
      method: 'POST',
      useToken: true,
      title: 'IntegrationFence - Create',
      data,
    }),
  update: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/integrationFenceUpdate',
      method: 'PUT',
      useToken: true,
      title: 'IntegrationFence - Update',
      data,
    }),
  delete: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/integrationFenceDelete',
      method: 'DELETE',
      useToken: true,
      title: 'IntegrationFence - Delete',
      params,
    }),
};

export { integrationFenceApi };
export default integrationFenceApi;
